import { render, staticRenderFns } from "./PanelCompetitionList.vue?vue&type=template&id=6efbff13&scoped=true&"
import script from "./PanelCompetitionList.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionList.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./PanelCompetitionList.vue?vue&type=style&index=1&id=6efbff13&scoped=true&lang=css&"
import style2 from "./PanelCompetitionList.vue?vue&type=style&index=2&id=6efbff13&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efbff13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6efbff13')) {
      api.createRecord('6efbff13', component.options)
    } else {
      api.reload('6efbff13', component.options)
    }
    module.hot.accept("./PanelCompetitionList.vue?vue&type=template&id=6efbff13&scoped=true&", function () {
      api.rerender('6efbff13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionList.vue"
export default component.exports